import type { ReactNode } from "react";
import type { GridColDef, GridValidRowModel } from "@mui/x-data-grid-premium";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type { ConnectedTenant } from "../api/registrations.types";
import { TenantIcon3 } from "./icons";
import { Grid } from "./Grid";

export const TenantControllerName = ({ children }: { children: ReactNode }) => (
  <Typography
    component="span"
    sx={{
      whiteSpace: "nowrap",
      fontSize: theme => theme.typography.pxToRem(12),
      color: theme => theme.palette.text.tertiary,
    }}
  >
    {children}
  </Typography>
);

export const connectedTenantsText = (tenants: ReadonlyArray<ConnectedTenant>) =>
  tenants.map(tenant => tenant.name).join(Grid.VALUE_GETTER_DELIMITER);

export const getConnectedTenantsQuickFilter =
  <Row extends GridValidRowModel>(
    getTenants: (row: Row) => ReadonlyArray<ConnectedTenant>,
    showControllerName: boolean
  ): GridColDef<Row>["getApplyQuickFilterFn"] =>
  searchValue => {
    const query = String(searchValue).toLowerCase();
    const includesQuery = (text?: string) => !!text?.toLowerCase().includes(query);
    return (_, row) =>
      getTenants(row).some(
        tenant =>
          includesQuery(tenant.name) || (showControllerName && includesQuery(tenant.personalDataController?.name))
      );
  };

export const ConnectedTenantEntry = ({ tenant, children }: { tenant: ConnectedTenant; children?: ReactNode }) => (
  <Typography
    component="div"
    sx={{
      display: "flex",
      gap: 1,
      minWidth: 0,
      fontSize: theme => theme.typography.pxToRem(14),
      color: theme => theme.palette.text.secondary,
    }}
  >
    <Box component="span" sx={{ display: "flex", alignItems: "center", height: "1lh", flexShrink: 0 }}>
      <TenantIcon3 size={16} color={theme => theme.palette.text.secondary} />
    </Box>
    <span>
      {tenant.name} {children}
    </span>
  </Typography>
);

export const ConnectedTenantsList = ({ children }: { children: ReactNode }) => (
  <Box sx={{ display: "flex", flexDirection: "column", rowGap: 0.5 }}>{children}</Box>
);
